import { HeatAgeThresholdsPage } from "./HeatAgeThresholdsPage";

const HeatAgeThresholds = () => {
	return <HeatAgeThresholdsPage />;
};

export default HeatAgeThresholds;
